<template >
<div class="container-fluid_">

<div class="row">
<div class="col-6">
  <div class="card border-success">
    <div style="background-color:#0066FF" class="card-header bg-primary text-white">
      <h4><i style="color:#FFD700" class="fas fa-edit mr-3" aria-hidden="true"></i>{{ couponId==0? 'NUOVO':'MODIFICA' }} PROMO COUPON</h4>
    </div>  
  <div class="card-body">    
  <alert-box @close="msg.title=''" v-bind:msg="msg" class="mt-2 mb-2"  ></alert-box>
  <waitingModal v-if="waitModal.show == true" @close="closeWaitingModal()"  v-bind:props="waitModal" ></waitingModal>
  <form v-on:submit.prevent="submit()">

    <store-vue-select :key="refresh_store"  @update="setStoreId" v-bind:props="store"></store-vue-select>

    <legend style="color:blue" class="col-form-label ">PERIODO EMISSIONE</legend>
    <div class="form-group">
        <label for="formGroupExampleInput4">Dal</label>
        <input required type="date" class="form-control" v-model="coupon.data1">
        
    </div>
    <div class="form-group">
        <label for="formGroupExampleInput4">Al</label>
        <input required type="date" class="form-control" v-model="coupon.data2">
        
    </div>

  <div  class="form-group mt-3">
    <!--<label for="formGroupExampleInput">Valore €</label>-->
    <div class="input-group ">
      <div class="input-group-prepend">
        <div  class="input-group-text"><strong>PER UN TOTALE ACQUISTI UGUALE O MAGGIORE DI €</strong></div>
      </div>  
      <input max="1000" required  step="0.01" min="0.01" type="number" class="form-control" v-model="coupon.total1" >      
    </div>
    
  </div>
  <legend style="color:blue" class="col-form-label ">TIPO COUPON DA STAMPARE</legend>
    <div class="form-check form-check-inline mb-3">
      <input  class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" :value="1" v-model="coupon.typeId" checked>
      <label class="form-check-label" for="inlineRadio1">EURO</label>
    </div>
    <div class="form-check form-check-inline mb-3">
      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" :value="2" v-model="coupon.typeId">
      <label class="form-check-label" for="inlineRadio2">SCONTO</label>
    </div>


    <div  class="form-group mt-3">
    <!--<label for="formGroupExampleInput">Valore €</label>-->
    <div class="input-group ">
      <div class="input-group-prepend">
        <div  class="input-group-text"><strong>{{ coupon.typeId == 1 ? 'VALORE IN EURO' : '% SCONTO' }} </strong></div>
      </div>  
      <input max="1000" required  step="0.01" min="0.01" type="number" class="form-control" v-model="coupon.total" >      
    </div>
    
  </div>

  <div >
      
</div>



  <legend style="color:blue" class="col-form-label ">PERIODO VALIDITA'</legend>
  <div class="form-group">
        <label for="formGroupExampleInput4">Dal</label>
        <input required type="date" class="form-control" v-model="coupon.data3">
        
    </div>
    <div class="form-group">
        <label for="formGroupExampleInput4">Al</label>
        <input required type="date" class="form-control" v-model="coupon.data4">
        
    </div>

  

  <div  class="form-group mt-3">
    <!--<label for="formGroupExampleInput">Valore €</label>-->
    <div class="input-group ">
      <div class="input-group-prepend">
        <div  class="input-group-text"><strong>VALIDO PER UN TOTALE ACQUISTI UGUALE O MAGGIORE DI €</strong></div>
      </div>  
      <input max="1000" required  step="0.01" min="0.01" type="number" class="form-control" v-model="coupon.total2" >      
    </div>
    
  </div>
  

  <div class="form-group">
    <label for="formGroupExampleInput2">Descrizione</label>
    <input required type="text" class="form-control" v-model="coupon.description"> 
        
  </div>



      <button @click="$emit('update')" type="button" class="btn btn-secondary mr-3">
        <i style ="color:yellow" class="fas fa-reply mr-3" aria-hidden="true"></i>
        RITORNA A LISTA COUPON
      </button>

      <button v-if="couponId==0" :disabled="spinner" type="submit" class="btn btn-primary float-right">
        <i  style="color:#FFCC00" class="fas fa-save mr-3" aria-hidden="true"></i>
         REGISTRA
         <span v-if="spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
      </button>
      <button v-if="couponId>0" :disabled="spinner" type="submit" class="btn btn-primary float-right">
        <i  style="color:#FFCC00" class="fas fa-save mr-3" aria-hidden="true"></i>
         MODIFICA
         <span v-if="spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
      </button>
      
</form>
</div>
</div> 
    


</div>
</div>



</div>
</template>
<script>


import api                        from '@/api'
import alertBox                   from '@/components/common/AlertBox.vue';
import { mapGetters }             from 'vuex';


import waitingModal               from "@/components/common/WaitingModal.vue"  


import storeVueSelect             from '@/components/common/StoreVueSelect2.vue'
export default {
  mixins:[],
  components: {alertBox,waitingModal,storeVueSelect},
  props    : ['couponId'],
 data () {
    return {
     refresh_store    : 0, 
     store             : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        Ids           : '',
        selection     : [],
      },

      waitModal    : {

        sentinel   : 0,
        show       : false,
        msg1       : 'REGISTRAZIONE IN CORSO ...',
        msg2       : 'CONTROLLARE LISTA COUPON.' 

      },  
    cash        : 0,
    coupon      : {typeId:1,'total':0.00},
    deskId      : 1,
    spinner     : false,
    
    
    //option    : 0,
    msg : {
        title : '',
        body  : '',
        type  : 0
      }


    }
  },
  directives: 
    {
      focus: {
      
        inserted: function (el) {
          
          el.focus()
          }
           
       
      }
    },
  computed: {
    ...mapGetters(['company','storeId']) 
  },
mounted()
{

 
    
},  
created()
{ 
  //this.initCoupon()
  if(this.couponId)
  {
    this.getData()
  
    return
  }
  this.initCoupon()
  
},
methods :{


setStoreId(Ids)
    {

      
      this.store.selection = Ids
      let storeIds = ''
      if (Ids.length > 0)
      {
        storeIds = Ids.join() 
      }
       
      this.store.Ids = storeIds
      console.log(Ids)
    
      
    },    
closeWaitingModal()
    {
      this.waitModal.show = false
      this.waitModal.sentinel = 0
      
    },
setCoupon(n)
{
  
  let date              = new Date()
  
  let expire_at         = date.setDate(date.getDate() + n)    
  let newDate           = new Date(expire_at).toISOString().slice(0, 10)
  this.coupon.expire_at = newDate

}, 
initCoupon()
{
  
  this.store.selection = []
  //this.coupon.typeId    = 'CASH'
  this.coupon.total     = 0
  this.coupon.total1    = 0
  this.coupon.total2    = 0
  this.coupon.description = ''
  
  this.coupon.typeId    = 1
  this.coupon.data1     = ''
  this.coupon.data2     = ''
  this.coupon.data3     = ''
  this.coupon.data4     = ''
  this.coupon.deskId    = 1
  this.coupon.storeId   = this.storeId
  this.coupon.active    = 0
   
  
  
},

async submit()
{

  if(this.couponId)
  {
    this.updateCoupon()
    return
  }

  this.msg.title = ''

  const sp         = {'sp'   : 'spCreatePromoCoupon'}
  const data       = {'data' : this.coupon }
  
    
  data.companyId   = this.company.Id 
  data.storeIds    = this.store.Ids.split(',')
  const json       = Object.assign(data, sp)
  
  
  //this.spinner = true
  this.waitModal.show  = true   
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              
              this.waitModal.sentinel = 1 
              this.$nextTick(() => {
                  this.$emit('update')
              
                  })     
                     
                         
            }
           else if(res.status==500)
           {               
                this.waitModal.sentinel = 3  
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                this.waitModal.sentinel = 2                 
                
                /*
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                */
                
                 
            } 
        
          }).catch(err => {
              
              this.waitModal.sentinel = 3
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},

async getData()
{

  this.msg.title = ''

  const sp         = {'sp'   : 'spPromoCouponByCouponId'}
  const data       = {'couponId' : this.couponId }
  
    
  
  
  const json       = Object.assign(data, sp)
  
  
  this.spinner = true
  this.waitModal.show  = true   
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              
              this.waitModal.sentinel = 1 
              
              this.coupon = res.data.recordsets[0][0]
              
              console.log(res.data.recordsets[1])
              this.store.selection = []
              res.data.recordsets[1].forEach(item => {
                this.store.selection.push(item.storeId)
              });
              this.store.Ids = this.store.selection.join()
              this.refresh_store++

         
                             
                         
            }
           else if(res.status==500)
           {               
                this.waitModal.sentinel = 3  
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                this.waitModal.sentinel = 2                 
                
                /*
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                */
                
                 
            } 
        
          }).catch(err => {
              
              this.waitModal.sentinel = 3
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},


async updateCoupon()
{
  
  this.msg.title = ''
  const sp    = {'sp' : 'spUpdatePromoCoupon'}
  const stores  = {'storeIds' : this.store.Ids.split(',')}
  //data.storeIds    = this.store.Ids.split(',')
  const json  = Object.assign(stores, sp,this.coupon)
  

  this.spinner = true
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              
              //this.coupon = {}
             // this.initCoupon()
            
              this.msg.title = 'MODIFICA COUPON EFFETTUATA.'
              this.msg.body  = ''
              this.msg.type  = 0
                 
                         
            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},


}

}

</script>
<style scoped>


h4 {
  font-family: "Roboto Condensed";
  font-size: 20px;
}
label,legend{
  font-weight: bold;
}
.form-check-label
{
  cursor: pointer;
}
</style>
